import { useEffect, useState } from "react";

const convertToCsv = (array: Array<any>) => {
    const csvRows = [];
    // Add header row if dataArray has keys
    if (Array.isArray(array) && array.length > 0) {
        const headers = Object.keys(array[0]);
        csvRows.push(headers.join(','));
    }

    array.forEach((row) => {
        const values = Object.values(row);
        const csvRow = values.map((value) => `"${value}"`).join(',');
        csvRows.push(csvRow);
    });

    return csvRows.join('\n');
};

export const downloadCsv = (dataArray: Array<any>, fileName: string) => {
    const csvData = convertToCsv(dataArray);
    const csvContent = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvData);
    const link = document.createElement('a');
    link.setAttribute('href', csvContent);
    link.setAttribute('download', `${fileName}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};